import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "ffh_admin_token";

export const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && (config.url || "").startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (token && (config.url || "").startsWith("/auth/me")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && url.startsWith("/admin")) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export function errorCode(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.response?.status === 429 ? "rate_limited" : "network";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "validation";
  return d.code || "error";
}
